import { API } from 'src/API'
import { create } from 'zustand'
import axios from 'src/API/config'

export const useDictionariesStore = create((set) => ({
  timezones: null,
  subscriptions: null,
  categories: null,
  isDictionariesLoading: false,
  loadTimezones: async () => {
    try {
      const res = await axios.get(API.COMMON.timezonesEndpoint)
      set({ timezones: res?.data?.data || [] })
    } catch (e) {
      console.log(e)
    }
  },
  loadSubscriptions: async () => {
    try {
      const res = await axios.get(API.COMMON.subscriptionEndpoint)

      const formattedOptions = res?.data?.data?.map((option) => {
        return { value: option?.id, label: option?.name }
      })

      set({ subscriptions: formattedOptions || [] })
    } catch (e) {
      console.log(e)
    }
  },
  loadCategories: async () => {
    try {
      const res = await axios.get(API.COMMON.categoriesEndpoint)

      const formattedOptions = res?.data?.data?.map((option) => {
        return { value: option?.id, label: option?.title }
      })

      set({ categories: formattedOptions || [] })
    } catch (e) {
      console.log(e)
    }
  }
}))
